import { Box } from "@mui/material";
import type { ReactNode, SyntheticEvent } from "react";

function stopSheetSwipe(event: SyntheticEvent): void {
  // Fast-Scroll bekommt die Geste weiterhin zuerst. Wir verhindern nur, dass
  // SwipeableDrawer dieselbe Touch-/Pointer-Geste anschließend als
  // Schließen-Wisch interpretiert.
  event.stopPropagation();
}

export default function SheetScrollbarGuard({ children }: { children: ReactNode }) {
  return (
    <Box
      data-sheet-scrollbar-guard
      sx={{ display: "contents" }}
      onTouchStart={stopSheetSwipe}
      onTouchMove={stopSheetSwipe}
      onTouchEnd={stopSheetSwipe}
      onTouchCancel={stopSheetSwipe}
      onPointerDown={stopSheetSwipe}
      onPointerMove={stopSheetSwipe}
      onPointerUp={stopSheetSwipe}
      onPointerCancel={stopSheetSwipe}
    >
      {children}
    </Box>
  );
}
